import styled from "styled-components";

import Body from "../../../../shared/styles/typography/Body.styled";
import { Summary } from "../../../../shared/styles/typography/Summary.styled";

const CardContent = styled.div`
  ${Summary}, ${Body} {
    margin-top: 8px;
  }

  .done-image {
    display: none;
  }
`;

export default CardContent;
